// Generated by src/localization/generateCatalogs.cjs. Do not edit.
export const catalogFeatures = ["common","home","auth","support","legal","race","admin"] as const;
export type CatalogFeature = typeof catalogFeatures[number];
export const catalogImports = {
  "ca": {
    common: () => import("./ca/common"),
    home: () => import("./ca/home"),
    auth: () => import("./ca/auth"),
    support: () => import("./ca/support"),
    legal: () => import("./ca/legal"),
    race: () => import("./ca/race"),
    admin: () => import("./ca/admin"),
    patterns: () => import("./ca/patterns"),
  },
  "es": {
    common: () => import("./es/common"),
    home: () => import("./es/home"),
    auth: () => import("./es/auth"),
    support: () => import("./es/support"),
    legal: () => import("./es/legal"),
    race: () => import("./es/race"),
    admin: () => import("./es/admin"),
    patterns: () => import("./es/patterns"),
  },
  "fr": {
    common: () => import("./fr/common"),
    home: () => import("./fr/home"),
    auth: () => import("./fr/auth"),
    support: () => import("./fr/support"),
    legal: () => import("./fr/legal"),
    race: () => import("./fr/race"),
    admin: () => import("./fr/admin"),
    patterns: () => import("./fr/patterns"),
  },
  "de": {
    common: () => import("./de/common"),
    home: () => import("./de/home"),
    auth: () => import("./de/auth"),
    support: () => import("./de/support"),
    legal: () => import("./de/legal"),
    race: () => import("./de/race"),
    admin: () => import("./de/admin"),
    patterns: () => import("./de/patterns"),
  },
  "pt-BR": {
    common: () => import("./pt-BR/common"),
    home: () => import("./pt-BR/home"),
    auth: () => import("./pt-BR/auth"),
    support: () => import("./pt-BR/support"),
    legal: () => import("./pt-BR/legal"),
    race: () => import("./pt-BR/race"),
    admin: () => import("./pt-BR/admin"),
    patterns: () => import("./pt-BR/patterns"),
  },
  "it": {
    common: () => import("./it/common"),
    home: () => import("./it/home"),
    auth: () => import("./it/auth"),
    support: () => import("./it/support"),
    legal: () => import("./it/legal"),
    race: () => import("./it/race"),
    admin: () => import("./it/admin"),
    patterns: () => import("./it/patterns"),
  },
  "nl": {
    common: () => import("./nl/common"),
    home: () => import("./nl/home"),
    auth: () => import("./nl/auth"),
    support: () => import("./nl/support"),
    legal: () => import("./nl/legal"),
    race: () => import("./nl/race"),
    admin: () => import("./nl/admin"),
    patterns: () => import("./nl/patterns"),
  },
};
